import { InjectionToken } from '@angular/core';
import { ChannelAppType } from '../enum/channel-app-type.enum';
export const CDN_CONFIG = new InjectionToken<string>('cdn.config', {
    providedIn: 'platform', factory: () => ''
});

export const MICRO_APPS = new InjectionToken<string[]>('micro.apps', {
    providedIn: 'platform', factory: () => []
});

export const CURRENT_TASK = new InjectionToken<string>('current.task', {
    providedIn: 'platform', factory: () => ''
});

export const CHANNEL_APP = new InjectionToken<ChannelAppType>('channel.task', {
    providedIn: 'platform', factory: () => ChannelAppType.WEB
});

export const FIREBASE_CONFIG_APP = new InjectionToken<any>('config.firebase', {
    providedIn: 'platform', factory: () => {}
});

export const FIREBASE_APP = new InjectionToken<any>('app.firebase', {
    providedIn: 'platform', factory: () => {}
});

export const ANALYTICS = new InjectionToken<any>('analytics.firebase', {
    providedIn: 'platform', factory: () => {}
});

export const ENV_CONFIG = new InjectionToken<any>('enviroment.config',{
    providedIn: 'platform', factory: () => {}
})
